import { escapeSearchQuery } from './searchQueryEscape';

describe('escapeSearchQuery', (): void => {
  it('escapes reserved characters in a normal search query', (): void => {
    expect(escapeSearchQuery('id+isbn:value')).toBe('id\\+isbn\\:value');
  });

  it('retains the colon of a valid compact field prefix and escapes only its value', (): void => {
    expect(escapeSearchQuery('isbn:abc+def')).toBe('isbn:abc\\+def');
    expect(escapeSearchQuery('isbn:abc:def')).toBe('isbn:abc\\:def');
  });

  it('escapes the entire query for an unknown field prefix', (): void => {
    expect(escapeSearchQuery('unknown_field:abc')).toBe('unknown_field\\:abc');
  });

  it.each(['isbn :abc', 'isbn: abc', 'isbn : abc'])(
    'escapes the entire query when whitespace occurs around the colon: %s',
    (query: string): void => {
      expect(escapeSearchQuery(query)).toBe(query.replace(':', '\\:'));
    }
  );
});